export enum OfflineStates {
  UPDATING = 'updating',
  UP_TO_DATE = 'up_to_date',
  UPDATE_READY = 'update_ready',
  CHECK_UPDATE = 'check_update'
}
